module.exports = __webpack_public_path__ + "components/flag/static/square/xk-e64b5af46c6771690131936fce512c4f.svg";